// ============================================================================
// WHITEBOARD SERVICE - frontend/src/services/whiteboard.ts
// API calls for whiteboard functionality
// ============================================================================

import { api } from './api';

export interface WhiteboardUploadRequest {
  sessionId: string;
  sourceId: string;
  sourceName: string;
  imageBase64: string;
  diffMode: boolean;
  currentPhase?: string;
}

export interface WhiteboardUploadResponse {
  success: boolean;
  extractedInfo: string;
  sourceId: string;
  timestamp: string;
  isNewInfo: boolean;
}

export interface WhiteboardSource {
  sourceId: string;
  sourceName: string;
  lastUpload: string;
}

/**
 * Upload and process a whiteboard image
 */
export async function uploadWhiteboardImage(
  request: WhiteboardUploadRequest
): Promise<WhiteboardUploadResponse> {
  const response = await api.post('/api/whiteboard/upload', request);
  return response.data;
}

/**
 * Get list of whiteboard sources for a session
 */
export async function getWhiteboardSources(
  sessionId: string
): Promise<WhiteboardSource[]> {
  const response = await api.get(`/api/sessions/${sessionId}/whiteboards`);

  // Transform backend format to frontend format
  return response.data.sources.map((source: any) => ({
    sourceId: source.sourceId,
    sourceName: source.sourceName,
    lastUpload: source.timestamp  // Map timestamp to lastUpload
  }));
}

/**
 * Clear history for a specific whiteboard source
 */
export async function clearWhiteboardSource(
  sessionId: string,
  sourceId: string
): Promise<void> {
  await api.delete(`/api/whiteboard/source/${sessionId}/${sourceId}`);
}
